import { CloseButton } from '@descomplica/uee-ui-components';
import React from 'react';

import { AcessibilityMenu } from '../../acessibility-menu';

interface CurrentLessonHeaderProps {
  onClose: () => void;
  title: string;
}

export const CurrentLessonHeader = ({ onClose, title }: CurrentLessonHeaderProps) => {
  return (
    <div className="current-lesson-header">
      <h3 className="lesson-heading">{title}</h3>
      <div className="current-lesson-actions">
        <AcessibilityMenu />
        <CloseButton onClick={onClose} ariaLabel="Fechar aula" tabIndex={1} />
      </div>
    </div>
  );
};
